import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFile } from "@fortawesome/free-solid-svg-icons";
import Cookies from "js-cookie";
import axios from "../axios/axios";
import Swal from "sweetalert2";
import CVTemplate1 from "../components/consulter-cv-new-temp";
import { useNavigate } from "react-router-dom";
import ProtectedRoute from "../components/ProtectedRoute";

export default function ConsulterCvPourPostuler() {
  const token = Cookies.get("auth_token");
  const [user, setUser] = useState({});
  const [offreEmploi, setOffreEmploi] = useState({});
  const [cv, setCv] = useState({});
  const [formations, setFormations] = useState([]);
  const [experiences, setExperiences] = useState([]);
  const [langues, setLangues] = useState([]);
  const [competences, setCompetences] = useState([]);
  const [piecejointes, setPiecejointes] = useState([]);
  const idoffre = Cookies.get("idoffre");
  const navigate = useNavigate();
  const [chargement, setChargement] = useState(false);

  useEffect(() => {
    if (idoffre !== null) {
      getCv();
      getOffreEmplPourPostuler();
    } else {
      navigate(`${process.env.PUBLIC_URL}/consulter-voter-cv`);
    }
  }, []);

  const getOffreEmplPourPostuler = () => {
    axios
      .get(`/getOffrePourPostuler/${idoffre}`, {
        headers: {
          Accept: "application/json",
        },
      })
      .then((response) => {
        setOffreEmploi(response.data.offeremp);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getCv = () => {
    setChargement(true);
    axios
      .get("/consultCv", {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        console.log(response.data);
        console.log("response.data in post");
        if (response.data.msg == "cv-404") {
          navigate(`${process.env.PUBLIC_URL}/completer-voter-cv`);
        } else {
          setUser(response.data.user);
          setCv(response.data.cv);
          setFormations(response.data.formations);
          setExperiences(response.data.experiences);
          setLangues(response.data.langues);
          setCompetences(response.data.skills);
          setPiecejointes(response.data.ps);
        }
        setChargement(false);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const postuler = (e) => {
    e.preventDefault();

    Swal.fire({
      title: "Traitement en cours, veuillez patienter ...",
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    const form = new FormData();
    form.append("idCv", cv.id);
    form.append("idOffre", idoffre);
    form.append("cv", cv);

    axios
      .post("/postuleWithCv", form, {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        // Swal.close();
        Swal.fire({
          icon: "success",
          text: "Votre candidature a été envoyée avec succès",
          confirmButtonText: "Ok",
        });
      })
      .catch((err) => {
        console.log(err);
        Swal.close();
      });
  };

  const ajouterPieceJointe = (e) => {
    Cookies.set("addPJ", "addPJ");
    navigate(`${process.env.PUBLIC_URL}/modifier-cv/${cv.id}`);
  };

  const editeCV = (e) => {
    Cookies.remove("addPJ");
    navigate(`${process.env.PUBLIC_URL}/modifier-cv/${cv.id}`);
  };

  return (
    <ProtectedRoute>
      {chargement == true ? (
        <div className="container card text-center mt-5">
          <h4>Chargement .... </h4>
        </div>
      ) : (
        <div className="container-fluid overcover">
          <div className="container profile-box">
            <p
              style={{
                fontWeight: "600",
                fontSize: "18px",
                textAlign: "center",
                marginBottom: 2,
              }}
            >
              Pour avoir plus de chance assurez que votre CV est à jour,
              <a style={{ color: "red", cursor: "pointer" }} onClick={editeCV}>
                {" "}
                Cliquer ici{" "}
              </a>
              pour mettre à jour mon CV avant de postuler
            </p>

            <div className="row">
              <div
                className="col-6"
                style={{ marginTop: "5px", textAlign: "center" }}
              >
                {offreEmploi.have_pj == 1 ? (
                  <a
                    style={{ color: "#047104", cursor: "pointer" }}
                    onClick={ajouterPieceJointe}
                  >
                    <FontAwesomeIcon icon={faFile} /> Cliquer Ici pour ajouter
                    un document
                  </a>
                ) : null}
              </div>
              <div className="col-6">
                <button className="btn btn-success" onClick={postuler}>
                  Postuler{" "}
                </button>
              </div>
            </div>

            <br />

            <CVTemplate1
              cv={cv}
              formations={formations}
              experiences={experiences}
              competences={competences}
              langues={langues}
              piecejointes={piecejointes}
            />
          </div>
        </div>
      )}
    </ProtectedRoute>
  );
}
